export default __webpack_public_path__ + "static/wallpaper-1-pc-9bcf49575edd235f303603bc6eb4975b.png";